import { render, staticRenderFns } from "./MealNutritionFacts.vue?vue&type=template&id=caaa7b04&scoped=true&"
import script from "./MealNutritionFacts.vue?vue&type=script&lang=js&"
export * from "./MealNutritionFacts.vue?vue&type=script&lang=js&"
import style0 from "./MealNutritionFacts.vue?vue&type=style&index=0&id=caaa7b04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caaa7b04",
  null
  
)

export default component.exports